// Números de página que muestra la paginación de los listados (rubro, ciudad, provincia del
// directorio). Con solo «Anterior / Siguiente», la página 2.000 de Buenos Aires quedaba a 2.000 clics
// de la primera y Google no llegaba a las fichas del fondo. Además de las vecinas, se enlazan saltos
// de 10, 50, 100, 500 y 1000 hacia los dos lados: cualquier página queda a pocos clics de cualquier otra.
const STEPS = [1, 2, 10, 50, 100, 500, 1000];

/**
 * Lista ordenada de páginas a enlazar, con `null` donde hay un salto (se muestra «…»).
 * Siempre incluye la primera, la última y la actual.
 */
export function paginationItems(page, totalPages) {
  const total = Math.max(1, Math.floor(totalPages) || 1);
  const current = Math.min(total, Math.max(1, Math.floor(page) || 1));
  // Listados cortos: todas las páginas.
  if (total <= 9) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = new Set([1, total, current]);
  for (const step of STEPS) {
    if (current - step >= 1) pages.add(current - step);
    if (current + step <= total) pages.add(current + step);
  }
  const sorted = [...pages].sort((a, b) => a - b);
  const items = [];
  sorted.forEach((n, i) => {
    if (i > 0 && n - sorted[i - 1] > 1) items.push(null);
    items.push(n);
  });
  return items;
}

/** `?page=N` salvo la primera, que es la URL limpia (la canónica). */
export function pageHref(basePath, n) {
  return n > 1 ? `${basePath}?page=${n}` : basePath;
}
